// FAR-74: one place that names a Base Plan, so the create modal, the plan list
// and the Planning Board all say the same thing about the same Base Plan.
//
// FAR-57 names Base Plans by when they were generated, so the label is the
// timestamp plus who or what built it: "Oct 6, 2026, 5:00 AM (daily run)".

// What a plan with no Base Plan reads as. Plans created before FAR-50 have
// none; they were planned from whatever data was active at the time.
export const NO_BASE_PLAN = 'Latest data (no Base Plan)'

export function basePlanTime(createdAt) {
  if (!createdAt) return '—'
  const d = new Date(createdAt)
  if (Number.isNaN(d.getTime())) return '—'
  return d.toLocaleString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit',
  })
}

// basePlanLabel names a Base Plan record. Falls back to the id when the record
// isn't loaded, so the label never reads "undefined".
export function basePlanLabel(bp) {
  if (!bp) return NO_BASE_PLAN
  if (!bp.createdAt) return bp.id || NO_BASE_PLAN
  const by = bp.trigger === 'scheduled' ? 'daily run' : (bp.createdBy || 'planner')
  return `${basePlanTime(bp.createdAt)} (${by})`
}

// basePlanShortLabel is the same thing where space is tight (a table cell):
// the timestamp only.
export function basePlanShortLabel(bp) {
  if (!bp) return '—'
  return bp.createdAt ? basePlanTime(bp.createdAt) : (bp.id || '—')
}
